<template>
  <custom-dialog class="select-orgin-dialog" width="850px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <!-- 部门搜索 -->
      <div class="search">
        <el-form @submit.native.prevent>
          <el-form-item>
            <el-input :placeholder="$t('base_select_organ_dialog.bu_men_ming_cheng')" v-model="appKey" @input="filterTree" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <!-- 部门结构树 -->
      <div class="tree">
        <el-tree
          ref="tree"
          node-key="bizId"
          :data="organTree"
          :props="{ label: 'bizName' }"
          :expand-on-click-node="false"
          @node-click="handleNodeClick"
          :default-expanded-keys="expandedKeys"
          :check-strictly="true"
          :filter-node-method="filterNode"
          highlight-current
        >
          <span class="tree-item" slot-scope="{ node }">
            <span>{{ node.label }}</span>
          </span>
        </el-tree>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" :disabled="!organData" @click="saveOrganBind">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  props: {
    orgId: [String, Number],
    organ: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      appKey: '',
      organTree: [],
      expandedKeys: [],
      organData: undefined,
    };
  },
  mounted() {
    this.getOrganTree();
  },
  methods: {
    // 选中部门
    handleNodeClick: function (data) {
      if (data.bizType === 1) {
        this.organData = undefined;
        return;
      }
      this.organData = data;
    },
    // 搜索过滤事件
    filterTree: function (value) {
      this.$refs.tree.filter(value);
    },
    // 搜索过滤
    filterNode: function (value, data) {
      if (!value) {
        return true;
      }
      return data.bizName.indexOf(value) !== -1;
    },
    // 获取组织树
    getOrganTree: function () {
      this.$getJSON(apis.DepartmentTree, { orgId: this.organ.bizId }).then((res) => {
        this.expandedKeys = [res.data.bizId];
        this.organTree = [res.data];
      });
    },
    // 保存提交
    saveOrganBind: function () {
      const selected = this.model.tableSelect || [];
      const params = selected.map((t) => ({
        orgId: this.orgId,
        bizId: this.organData.departmentId,
        bizType: 2,
        toBizId: t.locationId,
        toBizType: 4,
      }));
      this.$postJSON(apis.organDeviceBindAutoAdd, params).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss">
.select-orgin-dialog {
  .tree {
    height: 410px;
    overflow-y: auto;
    .tree-item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      padding-right: 8px;
      width: 0;
      .el-checkbox__label {
        font-size: 12px;
      }
    }
  }
}
</style>
